var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSenegal(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53604)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9569 1.59837C20.8534 0.581242 18.4935 0.0107422 16.0004 0.0107422C13.5073 0.0107422 11.1474 0.581242 9.0439 1.59837L7.65259 16.0107L9.0439 30.4231C11.1474 31.4402 13.5073 32.0107 16.0004 32.0107C18.4935 32.0107 20.8534 31.4402 22.9569 30.4231L24.3482 16.0107L22.9569 1.59837Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 10.4455L17.3812 14.6968H21.8517L18.2352 17.3245L19.6165 21.5759L15.9999 18.9484L12.3834 21.5759L13.7649 17.3245L10.1484 14.6968H14.6186L15.9999 10.4455Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.0435 1.5988C3.69163 4.18674 0 9.6673 0 16.0106C0 22.3539 3.69163 27.8345 9.0435 30.4224V1.5988Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9568 1.5988V30.4224C28.3087 27.8345 32.0003 22.3539 32.0003 16.0106C32.0003 9.6673 28.3087 4.18674 22.9568 1.5988Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53604"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0107422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSenegal);
export default __webpack_public_path__ + "static/media/senegal.3b60fc01.svg";
export { ForwardRef as ReactComponent };